import { combineReducers } from 'redux'
import * as AT from '../actions/_types'

const sent = (prevState = [], action) => {
  switch (action.type) {
    case AT.BLASTS_RECEIVE: {
      return action.blasts
    }
    default: {
      return prevState
    }
  }
}

const unsent = (prevState = resetUnsent(), action) => {
  switch (action.type) {
    case AT.BLASTS_PREPARE: {
      const resetState = resetUnsent()

      return {
        ...resetState,
        isEmail: action.isEmail,
        addresseeContactInfo: action.addresseeContactInfo,
        selectedDoctorId: action.selectedDoctors,
        selectedLocationId: action.selectedLocations,
        dateRange: action.range,
        allLocationsSelected: action.allLocationsSelected,
      }
    }
    case AT.BLASTS_FETCHING: {
      return {
        ...prevState,
        isFetching: true,
      }
    }
    case AT.BLASTS_FETCH_SUCC: {
      return {
        ...prevState,
        isFetching: false,
        errorMessage: '',
      }
    }
    case AT.BLASTS_FETCH_FAIL: {
      return {
        ...prevState,
        isFetching: false,
        errorMessage: action.errorMessage,
      }
    }
    default: {
      return prevState
    }
  }
}

export default combineReducers({ sent, unsent })

function resetUnsent() {
  return {
    isEmail: false,
    isFetching: false,
    allLocationsSelected: false,
    addresseeContactInfo: { patients: [] },
    body: '',
    subject: '',
    errorMessage: '', // if falsey, then assume success
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/blast-messages.js